import { ETourId, type ITourConfig } from '../types';

/**
 * Successful draft run tour shown when a draft run completes without errors.
 *
 * Four steps guiding the user from completion to publish:
 * 1. Everything ran as expected — the completed status in the header
 * 2. Run Assistant — introduce the Run Assistant panel
 * 3. Control future runs — the Run Again button (triggers/inputs)
 * 4. Let's publish! — the Publish button
 */
export const successfulDraftRunTour: ITourConfig = {
  id: ETourId.SUCCESSFUL_DRAFT_RUN,
  steps: [
    {
      id: 'everything-ran-expected',
      target:
        '[data-tour-id="run-page-progress-indicator"] [data-slot="completion-status"]',
      titleKey: 'tours.successfulDraftRun.everythingRanExpected.title',
      descriptionKey:
        'tours.successfulDraftRun.everythingRanExpected.description',
      position: 'bottomRight',
    },
    {
      id: 'run-assistant',
      target: '[data-tour-id="run-assistant-toolbar-button"]',
      titleKey: 'tours.successfulDraftRun.runAssistant.title',
      descriptionKey: 'tours.successfulDraftRun.runAssistant.description',
      position: 'topLeft',
    },
    {
      id: 'control-future-runs',
      target: '[data-tour-id="run-inputs-and-triggers-toolbar-button"]',
      titleKey: 'tours.successfulDraftRun.controlFutureRuns.title',
      descriptionKey: 'tours.successfulDraftRun.controlFutureRuns.description',
      position: 'topLeft',
    },
    {
      id: 'lets-publish',
      target: '[data-tour-id="run-page-publish-button"]',
      titleKey: 'tours.successfulDraftRun.letsPublish.title',
      descriptionKey: 'tours.successfulDraftRun.letsPublish.description',
      finishLabelKey: 'tours.successfulDraftRun.letsPublish.finishLabel',
      position: 'bottomRight',
    },
  ],
  namespace: 'tours',
  variant: 'default',
  size: 'sm',
  analytics: {
    enabled: true,
    eventPrefix: 'tour_successful_draft_run',
    metadata: {
      tourName: 'Successful Draft Run',
    },
  },
  persistence: {
    strategy: 'localStorage',
  },
};
